<template>
  <modal @close="closeModal">
    <template slot="header">
      <h4 v-if="isRegister" class="modal-title">Registrar Elemento</h4>
      <h4 v-else class="modal-title">Editar Elemento</h4>
    </template>

    <form id="item_form" @submit.prevent="validate()" slot="body" class="text-center">
      <div class="md-layout">
        <div class="md-layout-item md-size-35 md-form-label">
          <label class="md-form-label">Linea de Negocio</label>
        </div>
        <div class="md-layout-item md-size-65">
          <md-field :class="validationClass('businessLine')">
            <label for="updatedItem.businessLineId">Linea de Negocio</label>
            <md-select
              data-vv-name="businessLine"
              v-validate="modelValidations.businessLine"
              v-model="updatedItem.businessLineId"
              name="updatedItem.businessLineName"
              id="updatedItem.businessLine"
            >
              <md-option :value="c.id" v-for="c in mbusinessLine" :key="c.id" required>{{ c.name }}</md-option>
            </md-select>
            <error-indicator :valid="validField('businessLine')"></error-indicator>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <label class="md-layout-item md-size-35 md-form-label">Nombre de Familia</label>
        <div class="md-layout-item md-size-65">
          <md-field :class="validationClass('name')">
            <md-input
              data-vv-name="name"
              v-validate="modelValidations.name"
              v-model="updatedItem.name"
              type="text"
              name="updatedItem.name"
            ></md-input>
            <span class="md-helper-text">Ingrese Nombre de Familia</span>
            <error-indicator :valid="validField('name')"></error-indicator>
          </md-field>
        </div>
      </div>

      <div class="md-layout">
        <label class="md-layout-item md-size-35 md-form-label">Código de Familia</label>
        <div class="md-layout-item md-size-65">
          <md-field :class="validationClass('code')">
            <md-input
              data-vv-name="code"
              v-validate="modelValidations.code"
              v-model="updatedItem.codename"
              type="text"
              name="updatedItem.code"
              disabled
            ></md-input>
            <span class="md-helper-text">Código de Familia</span>
            <error-indicator :valid="validField('code')"></error-indicator>
          </md-field>
        </div>
      </div>
    </form>

    <template slot="footer">
      <md-button class="md-info md-round" type="submit" form="item_form" :disabled="loading">listo</md-button>
    </template>
  </modal>
</template>

<script>
import ErrorIndicator from "@/components/Validation/ErrorIndicator";
import { watchTouchedProperties } from "@/utils";
import dataService from "../../../../services/catalog";

const modelValidations = {
  businessLine: {
    required: true,
  },
  name: {
    required: true,
  },
  code: {
    required: false,
  },
};

export default {
  components: {
    ErrorIndicator,
  },

  props: {
    editedItem: Object,
    isRegister: Boolean,
    loading: Boolean,
  },

  data() {
    return {
      updatedItem: {},
      modelValidations,

      mStates: [],
      mMunicipalitys: [],
      mbusinessLine: [],
    };
  },

  methods: {
    closeModal: function () {
      this.$emit("close");
    },

    validate() {
      this.$emit("update:loading", true);
      const sendObject = {
        original: this.editedItem,
        updated: this.updatedItem,
      };

      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          this.$emit("saved", sendObject);
        } else {
          this.$notify({
            message: "Llene Todos los campos Marcados",
            icon: "close",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "warning",
          });
        }
      });
    },

    // Miscelanius methods
    consultMetas(ruta, asign, arg1, arg2) {
      // Make query for metaDatas
      let configuret;

      if (arg2) {
        configuret = {
          id: arg1,
          extraId: arg2,
          noStore: true,
          collection: true,
        };
      } else {
        configuret = { id: arg1, noStore: true };
      }
      dataService.fetch(ruta, configuret).then((res) => {
        this[asign] = res;
      });
    },
  },

  mounted() {
    this.updatedItem = { ...this.editedItem };
    this.consultMetas("business_line", "mbusinessLine");
  },

  watch: {
    ...watchTouchedProperties("updatedItem", Object.keys(modelValidations)),
  },
};
</script>

<style lang="scss" scoped>
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>



// WEBPACK FOOTER //
// src/pages/Catalogs/Supplies/Existence/createFamily.vue